import { render, staticRenderFns } from "./KeyIngredientsSection.vue?vue&type=template&id=62e82d52&scoped=true&"
import script from "./KeyIngredientsSection.vue?vue&type=script&lang=js&"
export * from "./KeyIngredientsSection.vue?vue&type=script&lang=js&"
import style0 from "./KeyIngredientsSection.vue?vue&type=style&index=0&id=62e82d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e82d52",
  null
  
)

export default component.exports